import { axiosInstanceWithToken } from 'utils/axios';
import { IBucketFileFetchRequest, IBucketFileFetchResponse } from '../../server/types';

export const fetchBucketFiles = async (bucketId?: string | number, params?: IBucketFileFetchRequest) =>
  axiosInstanceWithToken().get<IBucketFileFetchResponse>(`buckets/${bucketId}/files`, { params });

export const syncBucketFiles = async () => axiosInstanceWithToken().post('buckets/sync');
